<template>
  <div class="card">
    <img class="card-image" :src="image" />
    <div class="card-body">
      <div class="content">{{ name }}</div>
      <img :src="rightArrowIcon" />
    </div>
  </div>
</template>

<script>
import rightArrowIcon from '@/components/SetupSteps/img/right-arrow.png'

export default {
  name: 'SetupModuleCard',
  props: {
    name: String,
    image: String
  },
  data() {
    return {
      rightArrowIcon
    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.card {
  cursor: pointer;
  width: 304px;
  height: 172px;
  background: #FFFFFF;
  box-shadow: 0px 8px 8px -3px rgba(0, 0, 0, 0.06), 0px 0px 2px 0px rgba(0, 0, 0, 0.06);
  border-radius: 8px;

  &:hover {
    box-shadow: 0px 8px 8px -3px rgba(0, 0, 0, 0.06), 0px 0px 2px 0px rgba(0, 0, 0, 0.06);
    border: 2px solid rgba(149, 191, 71, 0.2);
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .card-image {
    display: block;
    width: 48px;
    height: 48px;
  }
  .card-body {
    margin-top: 12px;
    display: flex;
    align-items: center;
    .content {
      height: 28px;
      line-height: 28px;
      font-size: 20px;
      word-break: break-word;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #95BF47;
    }
    img {
      width: 24px;
      height: 24px;
      margin-left: 4px;
    }
  }
}
</style>
